import script from "./SliderWithModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderWithModal.vue?vue&type=script&setup=true&lang=ts"

import "./SliderWithModal.vue?vue&type=style&index=0&id=0f30b0c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f30b0c2"]])

export default __exports__